module.exports = __webpack_public_path__ + "img/vpc10.493630c.png";